import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import defaultHead from "../../assets/image/default-head.png";
import myImage from "../../assets/image/ex.png";
import {
  Cell,
  CellBody,
  CellButton,
  CellFooter,
  CellHeader,
  Cells,
  GridItem,
  Grids,
  Label
} from "../../components/weui";
import { userService } from "../../services";
import { selectUser } from "../../stores";
import { urls } from "../../urls";
import { getAxiosError, isWechat } from "../../utils";


import "./index.css";

export const UserCenter = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const handleLogout = useCallback(async () => {
    try {
      await userService.logout();
      navigate(urls.login());
    } catch (err) {
      console.log(getAxiosError(err));
    }
  }, [navigate]);

  return (
    <React.Fragment>
      <div className="relative">
        <div className="pgBg" style={ { backgroundImage: `url(${myImage})` } }></div>
        <div className="absolute left-2/4 top-28 -translate-y-2/4 -translate-x-2/4 flex flex-col">
          <div className="w-24 h-24 rounded-full bgSelf">
            <img className="rounded-full w-full h-full" src={ user?.pic || defaultHead } alt="" />
          </div>
          <div className="user-name mt-2 text-xl">{ user?.name }</div>
        </div>
      </div>
      <div className="bgSelf">
        <Grids>
          <GridItem icon="icon-gerenxinxi" iconTitle="个人资料" className="w-1/3"
            onClick={ e => navigate(urls.profile()) } />
          <GridItem icon="icon-xiaoxitongzhi" iconTitle="消息" className="w-1/3"
            onClick={ e => navigate(urls.message()) } />
          <GridItem icon="icon-dianbiao" iconTitle="我的表计" className="w-1/3"
            onClick={ e => navigate(urls.meters()) } />
        </Grids>
      </div>
      <div className="mt-10">
        <Cells>
          <Cell active access onClick={ e => navigate(urls.support()) }>
            <CellHeader><Label className="textCor">服务热线</Label></CellHeader>
            <CellBody></CellBody>
            <CellFooter></CellFooter>
          </Cell>
        </Cells>
        {
          !isWechat() && <Cells className="mt-5">
            <CellButton type="warn" onClick={ handleLogout }>退出登陆</CellButton>
          </Cells>
        }
      </div>
    </React.Fragment>
  );
};
